import React from 'react'
import Layout from '../../Layout/Layout'
import gitex1 from '../../images/gitex1.PNG'

import gitex2 from '../../images/gitex2.PNG'

const Gitex_Nigeria = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>GITEX Nigeria </h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>
                 The GITEX Nigeria Government Leadership & AI Summit was a key forum where Moolu Venture
                  Lab's Managing Partner, Prince Ogbonna, and team members from Moolu Venture Capital 
                  LP engaged in crucial dialogues on the future of AI in Nigeria. The summit, held at
                   GITEX NIGERIA—West Africa's largest tech event—convened top ecosystem leaders and 
                   policymakers. This participation underlined Moolu's commitment to steering the 
                   national conversation on emerging technologies.
</p>

                <p className='light'>
                    Moolu Venture Lab's core belief is that the transformative impact of AI remains 
                    largely understated and under-estimated for Nigeria's development potential. 
                    This necessitates urgent and constructive engagement across all stakeholders
                     to ensure that the adoption of AI is fundamentally ethical, inclusive, and 
                     highly relevant to local contexts. Such purposeful dialogue is essential to
                      maximizing the benefits of AI for all Nigerian sectors.
                </p>
               </div>

                <div className='uk-width-1-2@s'>
                 <img src={gitex1} />
               </div>
            </div>







             <div className='uk-grid uk-margin-large-top'>
               <div className='uk-width-1-2@s'>
                   <img src={gitex2} />
               </div>

                <div className='uk-width-1-2@s'>
                          <p className='light'>
                          In a tangible display of this commitment, Prince Ogbonna 
                          had earlier authored the National Generative AI Policy for
                           Inclusive Innovation (Nigeria 2025–2030), a policy framework
                            proposition for the safe and impactful adoption of GenAI in both 
                            startups and public services. Moolu Venture Lab's presence at
                             the GITEX summit reinforced its dedication to taking AI's 
                             influence from high-level policy recommendations to practical,
                              scalable implementation, a vital step in unlocking Nigeria's
                               true potential.

                            </p>
                  
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default Gitex_Nigeria